import { useUnsaved } from "@/lib/unsaved";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserPlus, Save, Plus, X } from "lucide-react";
import api from "@/lib/api";
import { useGuild } from "./DashboardLayout";
import { Toggle, PageHead } from "@/components/kit";
import { RoleSelect } from "@/components/RoleSelect";

export default function AutoRoles() {
  const { guildId } = useGuild();
  const [cfg, setCfg] = useState(null);
  const save = useUnsaved(cfg, setCfg, () => saveRaw());
  const [newRole, setNewRole] = useState("");
  useEffect(() => { api.get(`/guilds/${guildId}/modules/autoroles`).then((r) => setCfg(r.data)); }, [guildId]);
  const saveRaw = async () => { await api.put(`/guilds/${guildId}/modules/autoroles`, { enabled: cfg.enabled, config: cfg.config }); toast.success("Auto-roles saved"); };
  if (!cfg) return <p className="text-zinc-500">Loading…</p>;
  const roles = cfg.config.roles || [];

  return (
    <div>
      <PageHead title="Auto-Roles" desc="Automatically assign roles to members when they join.">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-sm"><span className="text-zinc-400">Enabled</span><Toggle testid="autoroles-enabled" checked={cfg.enabled} onChange={(v) => setCfg({ ...cfg, enabled: v })} /></div>
          <button data-testid="autoroles-save" onClick={save} className="bg-volt text-volt-ink font-semibold rounded-md px-5 py-2 hover:bg-volt-hover flex items-center gap-2"><Save className="w-4 h-4" /> Save</button>
        </div>
      </PageHead>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 max-w-2xl space-y-4">
        <div className="flex items-center gap-2 font-head font-semibold"><UserPlus className="w-4 h-4 text-volt" /> Roles granted on join</div>
        <div className="flex flex-wrap gap-2">
          {roles.map((r, i) => (
            <span key={i} data-testid="autorole-chip" className="flex items-center gap-1 bg-black border border-zinc-800 rounded-full px-3 py-1 text-sm">
              {r} <button onClick={() => setCfg({ ...cfg, config: { ...cfg.config, roles: roles.filter((_, x) => x !== i) } })} className="text-zinc-500 hover:text-red-400"><X className="w-3.5 h-3.5" /></button>
            </span>
          ))}
          {roles.length === 0 && <span className="text-sm text-zinc-600">No roles yet.</span>}
        </div>
        <div className="flex gap-2">
          <RoleSelect guildId={guildId} value={newRole} onChange={setNewRole} testid="autorole-input" placeholder="— select a role to add —" className="flex-1" />
          <button data-testid="autorole-add" onClick={() => { if (newRole.trim()) { setCfg({ ...cfg, config: { ...cfg.config, roles: [...roles, newRole.trim()] } }); setNewRole(""); } }} className="bg-zinc-800 hover:bg-zinc-700 rounded-md px-4 flex items-center gap-1"><Plus className="w-4 h-4" /> Add</button>
        </div>
      </div>
    </div>
  );
}
